import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _extends from 'babel-runtime/helpers/extends';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
/* eslint-disable react/no-multi-comp */
import React, { Component } from 'react';
import { classToDOMCard } from 'react-mobiledoc-editor';
import PropTypes from 'prop-types';

export default (function (_ref) {
  var _class, _temp, _class2, _temp2;

  var ViewComp = _ref.renderWith,
      Editor = _ref.editWith,
      name = _ref.name,
      _ref$payload = _ref.payload,
      defaultPayload = _ref$payload === undefined ? {} : _ref$payload,
      _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === undefined ? '' : _ref$buttonText;
  var MobiledocCard = (_temp = _class = function (_Component) {
    _inherits(MobiledocCard, _Component);

    function MobiledocCard() {
      _classCallCheck(this, MobiledocCard);

      return _possibleConstructorReturn(this, (MobiledocCard.__proto__ || _Object$getPrototypeOf(MobiledocCard)).apply(this, arguments));
    }

    _createClass(MobiledocCard, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            isInEditor = _props.isInEditor,
            isEditing = _props.isEditing,
            edit = _props.edit,
            payload = _props.payload;

        if (!isInEditor) return React.createElement(ViewComp, payload);
        return !isEditing ? React.createElement(ViewComp, _extends({}, payload, { onClick: edit })) : React.createElement(Editor, this.props);
      }
    }]);

    return MobiledocCard;
  }(Component), _class.displayName = name, _class.propTypes = {
    isInEditor: PropTypes.bool.isRequired,
    isEditing: PropTypes.bool.isRequired,
    edit: PropTypes.func,
    payload: PropTypes.object
  }, _class.defaultProps = {
    payload: {},
    edit: function edit() {}
  }, _temp);
  var Button = (_temp2 = _class2 = function (_Component2) {
    _inherits(Button, _Component2);

    function Button() {
      _classCallCheck(this, Button);

      return _possibleConstructorReturn(this, (Button.__proto__ || _Object$getPrototypeOf(Button)).apply(this, arguments));
    }

    _createClass(Button, [{
      key: 'render',
      value: function render() {
        var _props2 = this.props,
            edit = _props2.edit,
            props = _objectWithoutProperties(_props2, ['edit']);

        var editor = this.context.editor;

        return React.createElement(
          'button',
          _extends({}, props, { onClick: function onClick() {
              return editor.insertCard(name, defaultPayload, edit);
            } }),
          buttonText || name
        );
      }
    }]);

    return Button;
  }(Component), _class2.displayName = name + 'Button', _class2.propTypes = {
    edit: PropTypes.bool
  }, _class2.defaultProps = {
    edit: false
  }, _class2.contextTypes = {
    editor: PropTypes.object
  }, _temp2);

  var Card = classToDOMCard(MobiledocCard);
  Card.Button = Button;
  Card.View = ViewComp;
  return Card;
});